import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { CheckCircle2, RefreshCw } from 'lucide-react'

interface IntegrationStatusProps {
  /** Nome da integração para exibir no tooltip */
  name: string
  /** ID do cupom na integração (null = não sincronizado) */
  couponId: string | null | undefined
  /** Se a ação de sync está em andamento */
  isSyncing: boolean
  /** Callback para iniciar sincronização */
  onSync: () => void
}

/**
 * Ícone de status de integração com tooltip
 * - Verde com check: sincronizado
 * - Amarelo com refresh: pendente de sync
 */
export function IntegrationStatus({ name, couponId, isSyncing, onSync }: IntegrationStatusProps) {
  const isSynced = Boolean(couponId)

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className={`h-6 w-6 ${
              isSynced
                ? 'text-green-500 hover:text-green-600'
                : 'text-yellow-500 hover:text-yellow-600'
            }`}
            onClick={onSync}
            disabled={isSyncing}
            aria-label={isSynced ? `Sincronizado com ${name}` : `Sincronizar com ${name}`}
          >
            {isSynced ? (
              <CheckCircle2 className={`h-4 w-4 ${isSyncing ? 'animate-spin' : ''}`} />
            ) : (
              <RefreshCw className={`h-4 w-4 ${isSyncing ? 'animate-spin' : ''}`} />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {isSynced ? `Sincronizado com ${name}` : `Clique para criar cupom na ${name}`}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
